import React from "react";
import { useSelector } from "react-redux";
import "./steps.less";
import IntlMessages from "@util/IntlMessages";
import { Card } from "../../BP2Components";
import { FormattedMessage } from "react-intl";

const FourthStep = (props) => {
   const { newsletterContent, templateSubscribers } = useSelector(({ newsletter }) => newsletter);
   let templateName;
   let templateSubject;
   let templateNewsletter;
   let coverPhotoURL;
   let emailsChecked = 0;
   templateSubscribers.forEach((sub) => sub.checked && emailsChecked++);
   newsletterContent.forEach((el) => {
      if (el.wId === props.id) {
         templateName = el.templateName;
         templateSubject = el.subject;
         templateNewsletter = el.newsletterName;
         coverPhotoURL = el.coverPhotoURL;
      }
   });
   return (
      <>
         <div>
            <div className="summary-header">
               <Card>
                  {" "}
                  <IntlMessages id="w.newsletter.summary" />{" "}
               </Card>
            </div>
         </div>
         <div className="summary-left-panel">
            <div>
               <div className="gx-mt-2 summary-left-panel__box">
                  <span>
                     <IntlMessages id="w.newsletter.templateName" />:
                  </span>
                  <span>{templateName}</span>
               </div>
               <div className="gx-mt-2 summary-left-panel__box">
                  <span>
                     <IntlMessages id="w.newsletter.templateSubject" />:
                  </span>
                  <span>{templateSubject}</span>
               </div>
               <div className="gx-mt-2 summary-left-panel__box">
                  <span>
                     <IntlMessages id="w.newsletter.group" />:
                  </span>
                  <span>{templateNewsletter}</span>
                  <span>
                     {emailsChecked === 1 ? (
                        <FormattedMessage id="w.newsletter.emailChecked">
                           {(formattedValue) => (
                              <span>{` ( ${emailsChecked} ${formattedValue} )`}</span>
                           )}
                        </FormattedMessage>
                     ) : (
                        <FormattedMessage id="w.newsletter.emailsChecked">
                           {(formattedValue) => (
                              <span>{` ( ${emailsChecked} ${formattedValue} )`}</span>
                           )}
                        </FormattedMessage>
                     )}
                  </span>
               </div>
            </div>
         </div>
      </>
   );
};

export default FourthStep;
